"use es6";

export const isArrayLike = x => x && typeof x.length === 'number';